export default [
    { id: 0, label: 'Em Processo', theme: { background: 'rgb(78,119,175)', color: 'white' }, icon: 'faTasks' },
    { id: 1, label: 'Ativo', theme: { background: 'rgb(106,223,72)', color: 'white' }, icon: 'faCheck'  },
    { id: 2, label: 'Suspenso', theme: { background: '#ffcc2c', color: 'white' }, icon: 'faHandPaper'  },
    { id: 3, label: 'Cancelado', theme: { background: '#ff0c31', color: 'white' }, icon: 'faTimes'  },
    { id: 4, label: 'Iniciado', theme: { background: 'rgb(151,204,239)', color: 'white' }, icon: 'faPowerOff'  },
]
